<template>
  <div class="container">
    <Header :banner="require('@/assets/images/banner/about.png')" />
    <section class="section section1">
      <div class="about percent80 fa box-center">
        <div class="percent50">
          <img
            :src="require('@/assets/images/about/about_why.png')"
            alt="图片"
            class="img"
          />
        </div>
        <div class="fcol fb percent33">
          <div >
            <h1
              
              class="font-size-22 font-blod text-center mb10"
            >
              公司简介
            </h1>
            <div
              
              class="line"
              style="margin-bottom: 30px"
            ></div>
            <div class="content font-size-14 c_333">
              <p class="text-indent">
                悟之信息科技（上海）有限公司（Woowis-Shanghai Co., Ltd. ），是一家专注于为客户提供全面软件服务的信息科技型企业，公司的服务对象遍布机关院校、商贸文化、金融制造等各类行业。
              </p>
              <p class="text-indent">
                经过多年的努力与积累，悟之信息科技在企业协作集成、电子商务平台、金融数据虚拟、无线移动应用、AI 人工智能技术等方面，先后荣获了多项国家颁发的发明专利、软件产品和著作权登记证书，成为上海市高新技术企业，上海市软件企业，在国内外相关软件领域始终处于领先地位。
              </p>
              <p class="text-indent">
                长期以来，悟之信息科技一直以探索科技发展的趋势为公司的奋斗目标，以持续性的研发投入为基础，以前瞻性的技术平台为依托，以领先性的管理工具为后盾。
              </p>
              <p class="text-indent">
               “能悟之者，可得圣道”。悟之信息科技（上海）有限公司将坚持为所有客户提供高品质的软件专业化服务，致力于与所有客户共创持续发展的长期合作伙伴关系。
              </p>
            </div>
          </div>
          <div class="mt180 fstart font-size-26">
            <div class="fcol percent50 ">
              <span class="finish font-blod mb5 ">1165+</span
              ><span class="finish font-blod ">项目完成</span>
            </div>
            <div class="fcol percent50">
              <span class="satisfied font-blod mb5">2568+</span
              ><span class="satisfied font-blod">满意的客户</span>
            </div>
          </div>
        </div>
      </div>
    </section>
    <section class="section section2">
      <h1 class="font-size-22 font-blod text-center mb10">
        荣誉资质
      </h1>
      <div class="line mb50"></div>
      <div class="certificate-box fcc">
        <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/1a.png')"
          ></el-image>
        <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/2a.png')"
          ></el-image>
        
      </div>
      <div class="certificate-box fcc">
        <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/3a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/4a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/5a.png')"
          ></el-image>
      </div>
      <div class="certificate-box fcc">
        <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/6a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/7a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/8a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/9a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/10a.png')"
          ></el-image>
      </div>
      <div class="certificate-box fcc">
        <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/11a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/12a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/13a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/14a.png')"
          ></el-image>
          <el-image
          style="width: 300px;"
          :src="require('@/assets/images/about/15a.png')"
          ></el-image>
      </div>
    </section>
    <Footer />
  </div>
</template>

<script>
import Header from "@/components/common/Header";
import Footer from "@/components/common/Footer";
export default {
  data() {
    return {};
  },
  components: {
    Header,
    Footer
  },
};
</script>

<style lang="scss" scoped>
.container {
  .line {
    width: 28px;
    height: 4px;
    margin: 0 auto 50px;
    background-color: #000;
  }
  .section1 {
    .about {
      word-break: break-all;
      line-height: 25px;
      letter-spacing: 1px;
      .finish {
        color: #f88293;
        text-shadow: 2px 2px 3px #dca5ad;
      }
      .satisfied {
        color: #b887f6;
        text-shadow: 2px 2px 3px #cebce6;
      }
    }
  }
  .section2 {
    .certificate-box {
      margin-bottom: 25px;
      flex-wrap: wrap;
      img {
        display: inline-block;
        width: 300px;
        &:not(:nth-last-child(1)){
          margin-right: 15px;
        }
      }
    }
  }
}
</style>